const GET_DEFAULT_CONTAINER_PROPS = () => ({
  redirects: {
    onComparisonRedirect: {
      to: "/"
    },
    onFavoriteRedirect: {
      to: "/"
    }
  }
});
export {
  GET_DEFAULT_CONTAINER_PROPS
};
